module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_f_erythristic.b327e173.png";